import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
export function TestimonialsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const testimonials = [{
    quote: 'Después de años comiendo pan que parecía cartón, finalmente encontré el método que me permite disfrutar sin culpa. El leudado biológico cambió mi cocina.',
    author: 'María L.',
    role: 'Celíaca hace 8 años'
  }, {
    quote: 'Como diabética, siempre tuve miedo del pan. Ahora puedo controlar mi glucosa y disfrutar de facturas caseras. Es liberador.',
    author: 'Carolina R.',
    role: 'Diabetes Tipo 2'
  }, {
    quote: 'No es solo un recetario, es entender POR QUÉ funciona. Ahora adapto cualquier pan a mi gusto y siempre sale perfecto.',
    author: 'Lucía M.',
    role: 'Mamá de niña celíaca'
  }];
  return <section ref={ref} className="w-full bg-wheat/10 px-4 py-16 md:py-24" data-id="element-115">
      <div className="max-w-6xl mx-auto" data-id="element-116">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-117">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-brown mb-6" data-id="element-118">
            Lo Que Dicen Quienes Ya Lo Probaron
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-119">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 30
        }} transition={{
          duration: 0.6,
          delay: 0.2 + index * 0.15
        }} className="bg-white rounded-2xl shadow-lg p-8 relative" data-id="element-120">
              <QuoteIcon className="w-10 h-10 text-wheat/30 absolute top-6 left-6" data-id="element-121" />
              <div className="mt-8" data-id="element-122">
                <p className="font-body text-base md:text-lg text-brown/90 leading-relaxed mb-6 italic" data-id="element-123">
                  "{testimonial.quote}"
                </p>
                <div className="border-t border-wheat/20 pt-4" data-id="element-124">
                  <p className="font-body font-semibold text-brown" data-id="element-125">
                    {testimonial.author}
                  </p>
                  <p className="font-body text-sm text-brown/60" data-id="element-126">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}